import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

const T3Technician: React.FC = () => {
  useSEO({
    title: 'TCP T3 BD T3 RSE T3 適任技術人員註冊 - 焯峯工程 | 大型工程技術監督',
    description: '焯峯工程提供專業TCP T3、BD T3及RSE T3適任技術人員註冊服務，專責大型工程項目的技術監督和管理。包括本地建築工程TCP T3監督、國內工廠T3監督服務。確保符合屋宇署要求，同時提供村屋僭建物申報、TCP T1、BD T1、國內T1服務。立即聯絡91898819獲取專業諮詢。',
    keywords: 'TCP T3,BD T3,RSE T3,T3適任技術人員,T3註冊,屋宇署監督,大型工程監督,TCP監督,建築工程監督,國內工廠監督,村屋僭建物申報,TCP T1,BD T1,國內T1,焯峯工程',
    canonical: '/t3-technician',
    schema: {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "TCP T3 BD T3 RSE T3 適任技術人員註冊服務",
      "description": "提供專業TCP T3、BD T3及RSE T3適任技術人員註冊制度服務，專責大型工程項目的技術監督和管理",
      "provider": {
        "@type": "Organization",
        "name": "焯峯工程有限公司",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
      },
      "areaServed": [
        {
          "@type": "Place",
          "name": "香港"
        },
        {
          "@type": "Place",
          "name": "中國內地"
        }
      ],
      "serviceType": "大型工程技術監督服務"
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-red-50 to-red-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              T3適任技術人員註冊服務
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              提供專業T3適任技術人員註冊制度服務，專責大型工程項目的技術監督和管理
            </p>
          </div>
        </div>
      </section>

      {/* Professional Scope */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/5cb282170cd41e741d62dfd01ea770e4.png"
                alt="T3適任技術人員服務"
                className="w-full h-96 object-contain rounded-lg shadow-lg bg-gray-50"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">屋宇署適任技術人員註冊制度 - T3技術人員</h2>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">本地建築工程 TCP T3 監督服務</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">國內工廠 T3 監督服務</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Upload Sections */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">監督服務範例</h2>
            <p className="text-lg text-gray-600">專業T3監督服務實例</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* 內地玻璃熱浸監督 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/dd7c47c0414f6632f861823666b50fd5.jpeg"
                alt="內地玻璃熱浸監督"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">內地玻璃熱浸監督</h3>
                <p className="text-gray-600">Heat Soak Process 專業監督服務</p>
              </div>
            </div>

            {/* 內地工廠物料生產監督 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/aa55173e565f0b2825fc1458ff384848.jpeg"
                alt="內地工廠物料生產監督"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">內地工廠物料生產監督</h3>
                <p className="text-gray-600">Superstructure 物料生產監督服務</p>
              </div>
            </div>

            {/* 香港工地T3監督 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/24392fc03f25bfdb75c33edb65c96d53.jpeg"
                alt="香港工地T3監督"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">香港工地T3監督</h3>
                <p className="text-gray-600">本地建築工程TCP監督服務</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">需要T3適任技術人員服務？</h2>
          <p className="text-xl text-red-100 mb-8">專業的T3技術團隊為您的大型工程項目保駕護航</p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即諮詢
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default T3Technician;
